<template>
  <button
    type="button"
    class=" font-light text-lg py-2 px-6
      block rounded-full cursor-pointer
       border-solid border-2
      disabled:cursor-not-allowed boton-principal1
    " 
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  name: 'ButtonBase',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>
